export class PersonnelDetail {

    Cle:number;
    Reference:string;
    Nom:string;
    Prenom:string;
    Adresse:string;
    NumAdresse:string;
    NumBoite:string;
    NumEtage:string;
    CommuneCode:string;
    CommuneLib:string;
    PaysLib:string;
    email:string;
    telephone:string;
    telephoneprof:string;
    gsm:string;
    gsmprof:string;

  constructor() {}
}
